<div class="es-patient-card" *ngIf="pat && pat.ID !== 'default'">

  <div class="es-patient-card__header">
    <!-- Add button — callers project a (click) handler via ng-content slot or use @Output if needed -->
    <ng-content select="[card-add-btn]"></ng-content>

    <div class="es-patient-card__avatar">
      <mat-icon class="es-patient-card__avatar-icon">person</mat-icon>
    </div>
    <div class="es-patient-card__header-spacer"></div>
  </div>

  <!-- Optional warning message -->
  <div class="es-patient-card__warning" *ngIf="warningMsg">{{ warningMsg | translate }}</div>

  <div class="es-patient-card__name">{{ pat.First }} {{ pat.Last }}</div>

  <div class="es-patient-card__info">
    <div class="es-patient-card__info-row">
      <span class="es-patient-card__info-label">{{ 'GUI.General.ID Number' | translate | titlecase }}</span>
      <span class="es-patient-card__info-value">{{ pat.ID }}</span>
    </div>
    <div class="es-patient-card__info-row">
      <span class="es-patient-card__info-label">{{ 'GUI.General.Age' | translate | titlecase }}</span>
      <span class="es-patient-card__info-value">{{ patService.getAgeMo() }}</span>
    </div>
    <div class="es-patient-card__info-row"
         *ngIf="es.ExamType && es.ExamType !== 'Gynecology' && es.ExamType !== 'Follicles'">
      <span class="es-patient-card__info-label">{{ 'GUI.General.GA (at exam)' | translate }}</span>
      <span class="es-patient-card__info-value">{{ es.ExamType ? es.examGA() : pat.getGA() }}</span>
    </div>
    <!-- patexams GA fallback (no active exam) -->
    <div class="es-patient-card__info-row"
         *ngIf="!es.ExamType">
      <span class="es-patient-card__info-label">GA</span>
      <span class="es-patient-card__info-value">{{ pat.getGA() }}</span>
    </div>
    <!-- Caller-supplied extra rows (e.g. surrogate, archive link) -->
    <div class="es-patient-card__info-row" *ngFor="let row of extraRows">
      <span class="es-patient-card__info-label">{{ row.label }}</span>
      <span class="es-patient-card__info-value">{{ row.value }}</span>
    </div>
    <div class="es-patient-card__info-row" *ngIf="login.getArchiveServer()">
      <span class="es-patient-card__info-label">History</span>
      <span class="es-patient-card__info-value">
        <a target="_blank" [href]="login.getArchiveServer() + pat.ID">
          <img src="../../assets/icons/oldarchive.svg" style="height:1.6em;display:block;" />
        </a>
      </span>
    </div>
  </div>

  <!-- Button strip — callers project their own buttons here -->
  <div class="es-patient-card__btn-strip">
    <ng-content select="[card-btn-strip]"></ng-content>
  </div>

</div>
